<script>
import App from '@/pages/layouts/app.vue';
import Input from "@/pages/components/form/horizontal/input.vue";
import {useForm} from "@inertiajs/vue3";
import Modal from "@/pages/components/modal.vue";
import AjaxModal from "@/pages/components/ajax-modal.vue";
import Checkbox from "@/pages/components/form/horizontal/checkbox.vue";
import Card from "@/pages/components/card.vue";
import Table from "@wielink/datatables";

export default {
  components: {
    Card,
    Checkbox,
    App,
    Modal,
    AjaxModal,
    Input
  },
  props: {
      tableConfig: {
        type: String,
        required: true
      }
  },
  data() {
    return {
      form: useForm({
        firstname: '',
        lastname: '',
        email: '',
        remember: false
      })
    }
  },
  methods: {
    openModal() {
      this.$refs.modal.open();
    },
    openAjaxModal() {
      this.$refs.ajaxmodal.open();
    },
    submitForm() {
      this.form.post(route('elements.store'));
    },
    async customConfirm() {
      let confirm = await Helpers.Alert.confirm('Dit is een confirm');
      let value = confirm ? 'true' : 'false';
      Helpers.Alert.alert(`De waarde van de confirm is <b class="text-primary">${value}</b>`);
    },
    customAlert() {
      Helpers.Alert.alert('Dit is een alert');
    },
    flash() {
      Helpers.Message.success('Gelukt', 'success');
      Helpers.Message.error('Mislukt', 'success');
      Helpers.Message.warning('Waarschuwing', 'success');
      Helpers.Message.info('Informatie', 'success');
    }
  },
  mounted() {
    this.$nextTick(() => {
      new Table({
        scope: this.$refs.table
      })
    });
  }
}
</script>

<template>
  <App title="Elementen">
    <div class="row g-4 pb-4">
      <div class="col-12 col-lg-6">
        <Card class="h-100">
          <h2 class="card-title">Knoppen</h2>

          <div class="d-flex flex-wrap gap-2">
            <div>
              <button class="btn btn-primary">Primary</button>
            </div>
            <div>
              <button class="btn btn-secondary">Secondary</button>
            </div>
            <div>
              <button class="btn btn-success">Success</button>
            </div>
            <div>
              <button class="btn btn-danger">Danger</button>
            </div>
          </div>

          <h3 class="mt-3">Loaders</h3>

          <div class="d-flex flex-wrap gap-2">
            <div>
              <button class="btn btn-primary loading" disabled>Primary</button>
            </div>
            <div>
              <button class="btn btn-secondary loading" disabled>Secondary</button>
            </div>
            <div>
              <button class="btn btn-success loading" disabled>Success</button>
            </div>
            <div>
              <button class="btn btn-danger loading" disabled>Danger</button>
            </div>
          </div>

          <h3 class="mt-3">Responsive knoppen</h3>

          <div class="d-flex flex-wrap gap-2">
            <div>
              <button class="btn btn-responsive show-icon btn-primary">
                <i class="bi bi-plus-lg"></i>
                <span>Primary</span>
              </button>
            </div>
            <div>
              <button class="btn btn-responsive show-icon btn-secondary">
                <i class="bi bi-plus-lg"></i>
                <span>Secondary</span>
              </button>
            </div>
            <div>
              <button class="btn btn-responsive btn-success">
                <i class="bi bi-plus-lg"></i>
                <span>Success</span>
              </button>
            </div>
            <div>
              <button class="btn btn-responsive btn-danger">
                <i class="bi bi-plus-lg"></i>
                <span>Danger</span>
              </button>
            </div>
          </div>
        </Card>
      </div>

      <div class="col-12 col-lg-6">
        <Card class="h-100">
          <h2 class="card-title mb-4">Formulieren</h2>

          <form id="testform" @submit.prevent="submitForm">
            <Input v-model="this.form.firstname" :form="form" label="Voornaam" name="firstname" required/>

            <Input v-model="this.form.lastname" :form="form" label="Achternaam" name="lastname" required/>

            <Input groupClasses="mb-0" v-model="form.email" :form="form" label="E-mail" name="email" type="email" required/>

            <Checkbox v-model="form.remember" :form="form" name="remember" label="Blijf ingelogd" :value="true"/>
          </form>
        </Card>
      </div>

      <div class="col-12" v-if="$page.props.auth.permissions.includes('manage users')">
        <Card>
          <h2 class="card-title">Tabellen</h2>

          <div class="table-responsive">
            <table id="users" ref="table" class="table table-sm table-hover table-striped" :data-config="tableConfig"></table>
          </div>
        </Card>
      </div>
    </div>

    <Modal ref="modal" id="testmodal" title="Test" size="lg">
      Dit is dan de content

      <template #footer>
        <a href="#" data-bs-dismiss="modal" class="btn btn-secondary">Annuleren</a>
        <a href="#" class="btn btn-primary">Ok</a>
      </template>
    </Modal>

    <AjaxModal ref="ajaxmodal" :url="route('elements.ajax')" id="testmodal" size="lg"/>

    <template #topButtons>
      <div class="d-flex flex-wrap gap-2">

        <button @click="flash" class="btn btn-secondary">Meldingen</button>
        <button @click="customConfirm" class="btn btn-secondary">Confirm</button>
        <button @click="customAlert" class="btn btn-secondary">Alert</button>
        <button @click="openModal" class="btn btn-secondary">Modal openen</button>
        <button @click="openAjaxModal" class="btn btn-secondary">Ajax modal openen</button>

        <a href="#" class="btn btn-primary">
          <i class="bi bi-plus-lg"></i>
          Nieuw element toevoegen
        </a>
      </div>
    </template>

    <template #bottomButtons>
      <div class="d-flex gap-2">
        <a href="#" class="btn btn-secondary">Annuleren</a>
        <button form="testform" class="btn btn-responsive btn-primary">
          <i class="bi bi-floppy"></i>
          <span>Opslaan</span>
        </button>
        <button form="testform" class="btn btn-primary">
          <span>Opslaan en sluiten</span>
        </button>
      </div>
    </template>
  </App>
</template>